<template>
  <div class="contrastData">
    <div class="search"><!--contrastDataForm-->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="马帮销售订单">
          <el-input v-model="formInline.SaleOrder" placeholder="销售分单号" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">评估</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="materail">
      <div class="materailInfo">
        <div class="materailInfoItem padding-5-0" >产品名称:{{product.MaterialName}}</div>
        <div class="materailInfoItem padding-5-0">产品SKU:{{product.sku}}</div>
        <div class="materailInfoItem padding-5-0 flex flex-row-left flex-item-center">
          <div class="padding-0-5" style="padding-left: 0" >产品体积(cm³):{{product.FVolume}}</div>
          <div class="padding-0-5">长(CM):{{product.Length}}</div>
          <div class="padding-0-5">宽(CM):{{product.Width}}</div>
          <div class="padding-0-5">高(CM):{{product.Height}}</div>
        </div>
        <div class="materailInfoItem padding-5-0">产品重量(KG):{{product.FWeight}}</div>
      </div>

      <div class="materailTable">
        <el-table  :data="tableData" :preserve-expanded-content="true" :stripe="true" :border="true" :highlight-current-row="true" size="default" >
          <el-table-column  prop="platform" label="平台名称" width="150" />
          <el-table-column  prop="stock" label="仓库编码" width="150" />
          <el-table-column  prop="channel" label="渠道商" width="200" />
          <el-table-column  prop="price" label="预估运费" width="100" />
          <el-table-column  prop="estimatedDays" label="预估时间" width="100" />
          <el-table-column  prop="count" label="仓库可用库存" width="100" />
        </el-table>
      </div>
    </div>
  </div>

</template>

<script>
import {ElForm,ElFormItem,ElInput,ElButton,ElTable,ElTableColumn} from "element-plus";
import {deliverAndStore,deliver} from "@/utils/api"
export default {
  name: 'ContrastData',
  components: {
    ElButton,
    ElFormItem,ElForm,ElInput,ElTable,ElTableColumn
  },
  data(){
    return{
      formInline:{
        SaleOrder:'',
      },
      abType:"ALL",
      tableData:[],
      product:{},
      area:0,
      volume:0,
      weight:0,
    }
  },
  computed: {
    timeDefault() {
      var date = new Date(new Date());
      var s1 =
          date.getFullYear() + "-"+
          (date.getMonth() + 1 < 10 ? "0" : "") +
          (date.getMonth() + 1);
      return s1;
    },
  },
  beforeMount (){
    //this.getDatalist()
  },
  methods: {
    getDatalist(type='ALL'){
      //127.0.0.1
      //192.168.0.22
      deliverAndStore({...this.formInline,abType:type} ).then((res)=>{
        console.log(res)
      }).catch((err)=>{
        console.log(err)
      })
    },
    changeType(type){
      this.abType = type
      this.getDatalist(type)
    },
    onSubmit(){
      this.PageNumber = 1
      deliver({...this.formInline} ).then((res)=>{
        console.log(res)
        this.product = res.data.products
          this.tableData = res.data.shippingFeeList
      }).catch((err)=>{
        console.log(err)
      })
    },
  },

}
</script>

<style scoped>
.contrastData{
  width:90%;
  margin: 0 auto;
  font-size: 24px;
  padding: 30px 0;
}
.search{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.materail{
  padding-bottom: 100px;
}
.materailInfo{
  text-align: left;
  font-size: 14px;
}
.materailInfoItem{
}
.materailTable{
  width: fit-content;
  margin: 10px 0;
}
</style>